/**
 * @generated SignedSource<<1010e5f2d246b0b1ab035ceca8c71b07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BillingFrequency = "MONTHLY" | "ONE_TIME" | "YEARLY";
import { FragmentRefs } from "relay-runtime";
export type useGetPackagePriceMap_package$data = {
  readonly billingOptions: ReadonlyArray<{
    readonly billingCharges: ReadonlyArray<{
      readonly frequency: BillingFrequency;
      readonly squareVariation: {
        readonly amount: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "useGetPackagePriceMap_package";
};
export type useGetPackagePriceMap_package$key = {
  readonly " $data"?: useGetPackagePriceMap_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetPackagePriceMap_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetPackagePriceMap_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingOption",
      "kind": "LinkedField",
      "name": "billingOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingCharge",
          "kind": "LinkedField",
          "name": "billingCharges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "frequency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareItemVariation",
              "kind": "LinkedField",
              "name": "squareVariation",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "29389f2f4cb5acffe1e8c148a9f117ad";

export default node;
